import { useId } from 'react'
import { useFieldContext } from '~/hooks/form-hooks'
import { Field, type FieldProps } from './field'

type FileFieldProps = Omit<FieldProps, 'children' | 'error' | 'id'> & {
  accept?: string
  /** Nom du fichier déjà enregistré (mode édition) — affiché tant qu'aucun nouveau fichier n'est choisi. */
  defaultName?: string
  disabled?: boolean
}

export function FileField({
  label,
  optional,
  required,
  className,
  accept,
  defaultName,
  disabled,
}: FileFieldProps) {
  const field = useFieldContext<File | null>()
  const inputId = useId()

  const errorMessage = (field.state.meta.errors as { message: string }[]).at(0)?.message
  const currentName = field.state.value?.name ?? defaultName

  return (
    <Field
      id={inputId}
      label={label}
      optional={optional}
      required={required}
      error={errorMessage}
      className={className}
    >
      <input
        id={inputId}
        type="file"
        accept={accept ?? 'image/*'}
        disabled={disabled}
        onBlur={field.handleBlur}
        onChange={(event) => {
          const file = event.target.files?.[0]
          if (file) field.handleChange(file)
        }}
        className="w-full text-sm file:mr-3 file:rounded-md file:border file:border-border file:bg-muted file:px-3 file:py-1.5 file:text-sm file:font-medium hover:file:bg-muted/80"
        aria-invalid={errorMessage !== undefined}
      />
      {currentName && (
        <span className="text-muted-foreground text-xs">Fichier actuel : {currentName}</span>
      )}
    </Field>
  )
}
